module.exports = __webpack_public_path__ + "img/speed_bounce.38c46eb3.svg";